<template>
	<div :id="baseId" class="creators-showcase-panel d-flex flex-column">
		<div class="creators-showcase-panel-carousel d-flex flex-column">
			<div class="slide_header">
				<h1> The Proof is in the Reviews </h1>
				<div class = 'subtitle'>
					<h2> Excellent </h2>
					<h3> 4.5 out of 5 </h3>
					<img src = '@/assets/images/home/v8/trustpilot-logo.png' alt = 'Trustpilot Logo'>
				</div>
			</div>
			<div class="scroller" ref="scroller" @mouseenter="toggleScrolling(false)" @mouseleave="toggleScrolling(true)">
				<ul class="scroll__inner" ref="scrollerInner">

					<li v-for="(item, id) in creators"
						:key="`highlights-title-${id}`">

						<div class = 'review'>
							<div class = 'profile'>
								<div v-if=item.pfp class = 'avatar' :style="{ 'background-image': 'url(' + item.pfp + ')' }">
								</div>
								<div v-else class = 'avatar' :style="{ 'background-color': item.color }">
									<h3> {{ item.initials }} </h3>
								</div>
								<div class = 'username'>
									<h1> {{ item.name }} </h1>
									<h2> {{  item.date  }} </h2>

									<h3> @{{ item.handle }}</h3>

								</div>
							</div>
							<img class = 'stars' src = "@/assets/images/home/v8/stars-5.svg">
							<div class = 'expo'>
								<h3>
									{{ item.title }}
								</h3>
								<p>
									{{ item.text }}
								</p>
							</div>
						</div>
					</li>

				</ul>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { computed, defineProps, onMounted, ref } from 'vue'

	const props = defineProps({
		id: {
			type: [String, Number],
		},
		activeComponent: { type: Boolean },
	})

	const baseId = computed(() => `${props.id}`)
	const scroller = ref()
	const scrollerInner = ref()

	onMounted(() => {
		if (true) {
			addAnimation()
		}
	})



	function addAnimation() {
		scroller.value?.setAttribute('data-animated', true)
		const scrollerChildren = Array.from(scrollerInner.value.children)
		scrollerChildren.forEach(item => {
			const duplicateItem = item.cloneNode(true)
			duplicateItem.setAttribute('aria-hidden', true)
			scrollerInner.value.appendChild(duplicateItem)
		})
	}
	function toggleScrolling(keepScrolling) {
		scroller.value?.setAttribute('data-animated', keepScrolling)
	}

	const creators = [
		{
			name: 'Estela',
			handle: 'esteladelalcazar',
			date: 'Oct 8, 2024',
			email: '',
			title: 'I would sell a kidney for this thing',
			text: 'Okay I think I made the title a bit dramatic but in all seriousness I absolutely LOVE using Stan Store! I have a one stop shop to manage all of my store. I’m a personal finance coach and I’m able to handle and book 1:1 meetings, sell my digital products and have access to my referall links all in one place! This has truly been a game changer for me and I don’t see myself using anything else in the near future. Keep it up stan!',
			color: '#FF614C',
			pfp: '/images/home/v8/tp-estela.jpeg',
			initials: 'E',
		},
		{
			name: 'Tony',
			handle: 'content-with-tony',
			date: 'Nov 25, 2024',
			email: 'tony@contentwithtony.com',
			title: 'Stan is the GOLD STANDARD in all areas',
			text: 'The customer support, UI, and functionality are unparalleled. The experience of being their customer makes me not even consider other platforms for a second.',
			color: '#E969FF',
			pfp: '/images/home/v8/tp-tony.jpeg',
			initials: 'T',
		},
		{
			name: 'Yvonne',
			handle: 'yvonnesmink',
			date: 'Nov 21, 2024',
			email: 'yvonne.smink@gmail.com',
			title: 'Amazing experience with Stan',
			text: 'Amazing experience with Stan, super easy to use and quick to set up! Recommend 5/5',
			color: '#4CA6FF',
			pfp: '/images/home/v8/tp-yvonne.jpeg',
			initials: 'Y',
		},
		{
			name: 'Sarah',
			handle: 'bloatnomore',
			date: 'Sep 13, 2024',
			email: '',
			title: 'Obsessed with Stan Store',
			text: 'I love using the Stan Store. I have had such an amazing experience not only with setting up my store but Nathan has been so awesome to work with. He responds quickly to any questions or clarifications I have had. I highly recommend using Stan. I have 3 different accounts for 3 businesses and now that they have launched the community, I was able to cancel all my other platforms so that I could move into one! This is exactly what I was looking for :) I highly recommend!',
			color: '#FFBE4C',
			pfp: '/images/home/v8/tp-sarah.jpeg',
			initials: 'S',
		},
		{
			name: 'Brianna',
			handle: 'tongantoddler',
			date: 'Oct 11, 2024',
			email: 'support@tongantoddler.com',
			title: 'Stan Store is SO EASY to use!',
			text: 'Stan Store is SO EASY to use and made starting my online business such a good experience. Stan is user-friendly for both the seller and the customers. It\'s because of Stan Store that I have been able to start generating revenue for my family right now!',
			color: '#45EC7A',
			pfp: '/images/home/v8/tp-tongan.jpeg',
			initials: 'B',
		},


		{
			name: 'Olivia',
			handle: 'Livbooler',
			date: 'Oct 8, 2024',
			email: 'oliviabooler@hotmail.co.uk',
			title: 'The most simple supportive platform',
			text: 'Stan truly is the best platform to sell my digital products on. I love the notifications, the simplicity and the support! 5 stars just simply isn’t enough!',
			color: '#8679FF',
			pfp: '',
			initials: 'O',
		},
		{
			name: 'Anneke',
			handle: 'pinksparrowsocial',
			date: 'Dec 11, 2024',
			email: 'hello@pinksparrowsocial.com.au',
			title: 'Switching to Stan',
			text: 'I was using another platform that had all the bells and whistles and I kept telling myself “I’ll get to that” In reality I never did, it made me anxious knowing there was all these features I wasn’t using properly and I was paying way too much. Switching to Stan Store was the best decision. Everything is so straight forward, simple and easy to use.',
			color: '#FF4C4F',
			pfp: '/images/home/v8/tp-anneke.jpeg',
			initials: 'A',
		},
	]

</script>

<style lang="scss" scoped>
	.creators-showcase-panel {
		background: white;
		padding-top: 30px;
		position: relative;
	}

	li{
		height: fit-content;
	}

	.subtitle{
		display: flex;
		align-items: center;
		gap: 8px;
		width: fit-content;
		border-radius: 4px;
		margin: 24px auto;

		h2{
			font-size: 16px;
			font-weight: 700;
			margin: 0;
			white-space: nowrap;
		}
		h3{
			font-size: 14px;
			margin: 0;
			white-space: nowrap;
		}
		img{
			height: 28px;
		}
	}

	.review{
		background: white;
		box-shadow: 0 15px 25px rgba(#00106D, 0.1);
		padding: 20px;
		font-family: 'Inter', sans-serif;
		letter-spacing: -0.16px;
		width: 360px;
		margin-right: 24px;
		border-radius: 12px;

		.stars{
			height: 24px;
			margin-bottom: 20px;
		}

		.profile{
			display: flex;
			align-items: flex-start;
			gap: 10px;
			margin-bottom: 20px;
			.avatar{
				width: 40px;
				height: 40px;
				border-radius: 20px;
				background-size: cover;
				h3{
					width: 40px;
					line-height: 40px;
					color: white;
					text-align: center;
					font-size: 20px;
				}
			}
			.username{
				h1{
					font-size: 16px;
					font-weight: 700;
					margin: 0;
					margin-bottom: 2px;
				}
				h2{
					font-size: 13px;
					font-weight: 500;
					margin: 0;
					color: #808eb2;
				}
				h3{
						font-size: 13px;
						font-weight: 500;
						margin-top: 4px;
						color: #6355FF;
					}
			}
		}

		.expo{
			h3{
				font-size: 18px;
				font-weight: 700;
			}
			p{
				font-size: 14px;
				line-height: 135%;
				margin: 0;
			}
		}
	}


	.offset {
		transform: translateX(-100px);
	}
	.offset :hover {
		transform: scale(1.02);
	}
	.slide_highlight {
		padding-bottom: 0;
		background-color: none;
	}

	.slide_carousel {
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		background: none;
		padding: 120px 0;
		gap: 50px;

		.stat {
			width: 240px !important;
			height: 240px !important;
			background: #f5f5f5;
			border-radius: 50%;

			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			&:nth-child(1) {
				transform: translateY(var(--parallax-s3-1));
			}

			&:nth-child(2) {
				transform: translateY(var(--parallax-s3-2));
			}

			&:nth-child(3) {
				transform: translateY(var(--parallax-s3-2));
			}

			&.big {
				width: 280px !important;
				height: 280px !important;
			}

			h1 {
				font-size: 80px;
				font-weight: 900;
				margin: 0;
			}

			h2 {
				font-size: 40px;
				font-weight: 900;
				margin: 0;
			}

			h3 {
				font-size: 16px;
				font-weight: 400;
				letter-spacing: -0.2px;
				margin: 0;
				margin-top: 15px;
			}
		}
	}

	@media screen and (max-width: 767px) {

		.creators-showcase-panel{
			margin-bottom: -32px;
		}

		.slide_header{
			padding: 0;
		}

		.slide_carousel {
			display: flex;
			flex-direction: column;
			padding: 0;
		}
	}

	@media screen and (max-width: 767px) {
		.scroll {
			padding-left: 80px !important;

		}
		.highlight {
			margin-left: -50px;
			.expo {
				width: 70vw;
				padding: 20px;
			}
			.img {
				width: 70vw;
				height: 70vw;
				.expo {
					padding: 20px;
					h1 {
						font-size: 22px;
						margin-bottom: 5px;
					}
					h2 {
						margin-bottom: 10px;
					}
				}
			}
			.store {
				width: 30vw;
				margin-left: 50px;
				border-radius: 20px;
				width: 30vw;
				margin-left: 50px;
				border-radius: 20px;
			}
		}
	}

	.scroller {
		max-width: 90%;
		overflow-y: hidden;
		position: relative;
		transform: translateX(-50%);
		left: 50%;
	}

	.scroller {
		-webkit-mask: linear-gradient(90deg, transparent, white 10%, white 90%, transparent);
		mask: linear-gradient(90deg, transparent, white 10%, white 90%, transparent);
	}

	.scroller .scroll__inner {
		width: max-content;
		animation: scroll 60s linear infinite;
		animation-play-state: paused; /* Start paused */
		list-style: none;
	}

	.scroller[data-animated='true'] .scroll__inner {
		animation-play-state: running; /* Resume when the element is in view */
	}

	.scroll__inner {
		display: flex;
		gap: 0px;
		padding: 80px 30px 60px 100px;
		-ms-overflow-style: none;
		scrollbar-width: none;
	}

	.scroll__inner::-webkit-scrollbar {
		display: none;
	}

	@keyframes scroll {
		to {
			transform: translate(calc(-50% + 67px));
		}
	}

	@media screen and (max-width: 800px){
		.slide_carousel{
			padding: 32px 0;
		}
	}

</style>
